<div class="overflow-scroll-touch relative">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
